<template>
  <div class="agreement-container">
    <h1 class="agreement-title">Account Cancellation Instructions</h1>
    <p>Dear users:</p>
    <p>
      Hello! Thank you for using the software. If you decide to cancel your
      account, please read the following important information carefully:
    </p>
    <h2>I. Important Notice</h2>
    <p>
      The distribution area of this software does not include mainland China,
      and the account cancellation operation needs to follow specific rules and
      procedures.
    </p>
    <h2>II. Conditions for Account Cancellation</h2>
    <h3>1. Balance Requirement</h3>
    <p>
      Before applying for account cancellation, you need to ensure that the
      balance in your wallet is 0 or close to 0 (that is, the digits after the
      decimal point are 0 up to the 6th place), and the balance in your credit
      card must also be 0. This is to ensure the security of your funds and the
      accurate processing of your account information, avoiding any financial
      problems during the cancellation process.
    </p>
    <h3>2. Credit Card Cancellation</h3>
    <p>
      You must first cancel the Visa or MasterCard issued through this software.
      Before canceling the credit card, please ensure that all the balances in
      the card are transferred back to the wallet.
    </p>
    <h2>III. Cancellation Steps</h2>
    <h3>1. Handling Wallet Balance</h3>
    <p>
      Log in to the software and check the balance in your wallet. If the
      balance is not 0, please use the transfer function of the software to
      transfer the balance to other legal wallet addresses you own. After the
      transfer is completed, please confirm again whether the wallet balance
      meets the cancellation requirements.
    </p>
    <h3>2. Canceling the Credit Card</h3>
    <p>
      Find the credit card management-related functions in the software, select
      the credit card (Visa or MasterCard) you want to cancel, and then follow
      the system prompts to complete the cancellation process. After the
      cancellation is completed, please check the wallet balance to confirm that
      the credit card balance has been successfully transferred back.
    </p>
    <h3>3. Applying for Account Cancellation</h3>
    <p>
      When both the wallet balance and the credit card meet the above
      conditions, you can find the account cancellation option in the settings
      or account management module of the software, and click to apply for
      account cancellation. After we receive your application, we will conduct
      the necessary reviews. Once the review is passed, your account will be
      successfully cancelled.
    </p>
    <h2>IV. Terms of Use for Users Aged 18 and Above</h2>
    <h3>1. Age Confirmation</h3>
    <p>
      Before using this software and its related services, users need to confirm
      that they are 18 years old or above. If under 18 years old, please do not
      use this software, otherwise it may lead to consequences such as account
      suspension.
    </p>
    <h3>2. Responsibility Assumption</h3>
    <p>
      Users aged 18 and above shall be solely responsible for all their
      operational behaviors within the software, including but not limited to
      fund transactions, information filling, and function usage. Any
      consequences resulting from improper user operations or violations of laws
      and regulations shall be borne by the user.
    </p>
    <h3>3. Compliance with Laws and Regulations</h3>
    <p>
      Users need to comply with all laws and regulations in their region and the
      region where the software is operated, and shall not use the software for
      any illegal and criminal activities, such as money laundering, fraud,
      illegal fundraising, etc. If any illegal or irregular behavior of the user
      is found, this software has the right to immediately terminate the service
      and cooperate with relevant departments for investigation and handling.
    </p>
    <h3>4. Privacy Protection and Information Security</h3>
    <p>
      This software will strictly protect the personal information security of
      users in accordance with the privacy policy. However, users should
      properly safeguard their account information, including login passwords,
      payment passwords, wallet addresses, etc., to avoid losses caused by
      information leakage. If the information leakage is due to the user's own
      reasons, this software shall not bear the corresponding responsibility.
    </p>
    <h3>5. Service Change and Termination</h3>
    <p>
      This software has the right to change the content and rules of the
      software service or terminate part of the service according to its own
      operation situation or legal requirements. If the service change or
      termination has a significant impact on the user, this software will
      notify the user in advance. After receiving the notice, the user shall
      operate in accordance with the new regulations or requirements, otherwise
      it may affect the use of the account.
    </p>
    <h3>6. Dispute Resolution</h3>
    <p>
      If a dispute occurs between the user and this software during the use
      process, both parties should first try to resolve it through friendly
      negotiation. If the negotiation fails, a lawsuit can be filed with the
      people's court with jurisdiction in accordance with relevant laws and
      regulations.
    </p>
    <p>
      Please note that account cancellation is an irreversible operation. Once
      the cancellation is completed, you will not be able to use the software
      and all its related services anymore, including but not limited to USDT
      transfer, credit card usage, transfer, consumption, etc. At the same time,
      we will delete all your information and handle all your account data in
      accordance with our privacy policy and relevant laws and regulations.
    </p>
    <p>
      If you have any questions or need assistance during the cancellation
      process, please contact our customer service team.
    </p>
    <p>Service Email: mengxiangdao123@outlook.com</p>
  </div>
</template>
<script>
export default {
  name: "AccountDeletionStatement",
  created() {
    // 在组件创建时立即滚动到顶部
    window.scrollTo(0, 0);
  },
  mounted() {
    // 组件挂载后再次确保滚动到顶部
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
};
</script>

<style scoped>
.agreement-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.agreement-title {
  color: #333;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 2px solid #eee;
}

/* h2 {
  color: #2c3e50;
  font-size: 24px;
  margin-top: 30px;
  margin-bottom: 20px;
} */

ol {
  padding-left: 20px;
  line-height: 1.6;
}

li {
  margin-bottom: 12px;
  color: #666;
}

p {
  color: #666;
  line-height: 1.6;
}
</style>
